// extracted by mini-css-extract-plugin
module.exports = {"browsingChallengeHeader":"BrowsingChallenges_browsingChallengeHeader___eqyd","tabList":"BrowsingChallenges_tabList__NBhXo"};